"use client";
import { jsx as s } from "react/jsx-runtime";
import m from "clsx";
import d from "next/image";
import i from "next/link";
import { s as e } from "../Header.module-Bapke7fU.js";
const l = ({ wide: r, center: a, children: t }) => /* @__PURE__ */ s(
  "header",
  {
    className: m(e.header, {
      [e._wide]: r,
      [e._center]: a
    }),
    children: t
  }
);
l.displayName = "Header";
const n = ({
  image: r,
  alt: a,
  title: t,
  small: o
}) => /* @__PURE__ */ s(i, { href: "/", className: e.logo_link, children: /* @__PURE__ */ s(
  d,
  {
    src: r,
    className: m(e.logo_image, { [e.small]: o }),
    width: o ? 20 : 40,
    height: o ? 20 : 40,
    priority: !0,
    alt: a,
    title: t
  }
) });
n.displayName = "HeaderLogoImage";
const p = ({
  text: r,
  adaptive: a,
  small: t,
  hide: o
}) => /* @__PURE__ */ s(
  i,
  {
    href: "/",
    className: m(e.logo_text, {
      [e.adaptive]: a,
      [e.small]: t,
      [e.hide_on_desktop]: o === "desktop",
      [e.hide_on_mobile]: o === "mobile",
      [e.hide]: o === "always"
    }),
    children: r
  }
);
p.displayName = "HeaderLogoText";
export {
  l as Header,
  n as HeaderLogoImage,
  p as HeaderLogoText
};
